module.exports = __webpack_public_path__ + "img/payment.4d4e340f.svg";